import { TransferStatusEnum } from "@gtpl/shared-models/common-models";
import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { ForkLiftJobs } from "../fork-lift-jobs/fork-lift-jobs.entity";

@Entity('fork_lift_items')
export class ForkLiftItems {

    @PrimaryGeneratedColumn("increment",{name:'fork_lift_item_id'})
    forkLiftItemId:number;
    @Column("int",{
        nullable:true,
        name:"sale_order_id"
        })
        saleOrderId:number;
    @Column("int",{
        nullable:true,
        name:"sale_order_item_id"
        })
    saleOrderItemId:number;
    @Column("int",{
        nullable:false,
        name:"pallet"
        })
    pallet:number;
    @Column("int",{
        nullable:false,
        name:"current_position",
        default: 0
        })
    currentPosition:number;
    @Column("int", {
        nullable: false,
        default:0,
        name: "job_cartons",
        })
        jobCartons: number;
    @Column({
        type: 'decimal', precision: 10, scale: 3,
        nullable: false,
        default:0,
        name: "issued_quantity",
        })
        issuedQuantity: number;
    @Column({
        type: 'decimal', precision: 10, scale: 3,
        nullable: false,
        default:0,
        name: "received_quantity",
        })
        receivedQuantity: number;
    @Column("int",{
        nullable:false,
        name:"target_position",
        default: 0
        })
    targetPosition:number;
    @Column("int",{
        nullable:true,
        name:"real_position",
        default: 0
        })
    realPosition:number;
    @Column("int",{
        nullable:true,
        name:"fork_lift_job_id",
        default: 0
        })
    forkLiftJobId:number;
    @Column("datetime", {
        nullable: true,
        name: "date"
    })
    date: Date;
    @Column("int", {
        nullable: false,
        name: "unit_id",
        })
        unitId: number;
        @Column("int", {
            nullable: true,
            name: "stock_id",
            })
            stockId: number;
    @Column("boolean",{
        nullable:false,
        default:false,
        name:"sync_status"
        })
    syncStatus?:boolean;
    @Column({
        type: 'enum',
        enum: TransferStatusEnum,
        nullable: false,
        name: 'status',
        default:TransferStatusEnum.IN_TRANSIT,
    })
    status: TransferStatusEnum;
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      name: "created_user",
      default:"Admin",
      length:50
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user",
      length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;

  @Column("decimal", {
    nullable: false,
    default:0,
    name: "job_loose_pouches",
    precision:10,scale:3
    })
    jobLoosePouches: number;

    @Column("int", {
    name: "variant_id",
    })
    variantId: number;

    @Column("int", {
        name: "domestic_sale_id",
    })
    domesticSaleId: number;

    @Column('varchar',{
        name:'lot_no',
        length:50
    })
    lotNo : string

    @Column('int',{
        name:'ref_no'
    })
    refNo : number

    @Column('varchar',{
        name:'sequence',
        length:40
    })
    sequence : string

    @Column('int',{
        name:'pack_list_no'
    })
    packListNo : number
  

  @ManyToOne(type => ForkLiftJobs, forkLiftJobs => forkLiftJobs.forkLiftItemsInfo, { nullable: false, })
  @JoinColumn({ name: "fork_lift_job_id" })
  forkLiftJobInfo: ForkLiftJobs;
}
